import React from "react";
import Accordion from "../common/Accordion";

interface ProgramFAQsProps {
  title: string;
  faqs: {
    question: string;
    answer: string;
  }[];
}

const Faqs: React.FC<ProgramFAQsProps> = ({ title, faqs }) => {
  return (
    <div className="px-4">
      <div className="text-3xl text-black font-bold">{title}</div>
      <div className="mt-4 flex flex-col gap-4">
        {faqs?.length > 0 &&
          faqs?.map((question: any, index: number) => (
            <Accordion
              key={`program-faq-${index}`}
              title={question.question}
              description={question.answer}
            />
          ))}
      </div>
    </div>
  );
};

export default Faqs;
